import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const DEFAULT_ITEMS = [
  "Checks your heart, blood pressure and oxygen in about 60 seconds",
  "Spots early warning signs with smart AI cameras",
  "Connects you to a real doctor on video, when needed",
  "Prints your health report on the spot",
  "Cleans and sanitizes itself after every visitor",
  "Sends results straight to your doctor's records system",
];

export const Benefits = ({ title = "Everything the Hub does.", items = DEFAULT_ITEMS, testid = "benefits-section" }) => (
  <section className="py-24 lg:py-32 px-6 sm:px-12 max-w-4xl mx-auto" data-testid={testid}>
    <motion.h2
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1, ease: EASE }}
      className="font-display font-semibold tracking-tight text-[#3A3A3C] text-3xl sm:text-4xl leading-[1.15]"
    >
      {title}
    </motion.h2>
    <div className="mt-10">
      {items.map((b, i) => (
        <motion.div
          key={b}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-5%" }}
          transition={{ duration: 0.7, ease: EASE, delay: i * 0.05 }}
          className="flex items-baseline gap-6 py-5 border-b border-black/5 group"
          data-testid={`${testid}-item-${i + 1}`}
        >
          <span className="font-mono2 text-[11px] text-[#808080] tabular-nums">
            {String(i + 1).padStart(2, "0")}
          </span>
          <p className="font-display font-medium tracking-tight text-[#3A3A3C] text-lg sm:text-xl group-hover:translate-x-1 transition-transform duration-300">
            {b}
          </p>
        </motion.div>
      ))}
    </div>
  </section>
);
